import { gql } from "@apollo/client";

const GET_PRICE_LISTS = gql`
  query getPriceLists($companyId: Int!) {
    companyAdminContext {
      pricelists {
        getPriceLists(companyId: $companyId) {
          articlePriceListId
          description
          name
          isCompanyInvoicePriceList
        }
      }
    }
  }
`;

export default GET_PRICE_LISTS;